const permissions = {
  static: {
    users: {
      viewUser: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      addUser: { permissions: [10], currentUser: [] },
      editUser: { permissions: [10], currentUser: [1, 4, 6, 8, 10] },
      addUserCheckinProfile: { permissions: [10], currentUser: [] },
      editUserCheckinProfile: { permissions: [10], currentUser: [] },
      addUserButtons: {
        permissions: [6, 8, 10],
        currentUser: [1, 4, 6, 8, 10],
      },
      editUserButtons: {
        permissions: [6, 8, 10],
        currentUser: [1, 4, 6, 8, 10],
      },
      deleteUserButtons: {
        permissions: [6, 8, 10],
        currentUser: [1, 4, 6, 8, 10],
      },
      addSaraPreferences: { permissions: [10], currentUser: [] },
      editSaraPreferences: { permissions: [10], currentUser: [1, 4, 6, 8, 10] },
      addUserCategoryOrder: {
        permissions: [10],
        currentUser: [1, 4, 6, 8, 10],
      },
      editUserCategoryOrder: {
        permissions: [10],
        currentUser: [1, 4, 6, 8, 10],
      },
      editUserAlertGroups: {
        permissions: [10],
        currentUser: [10],
      },
      exportUsers: {
        permissions: [10],
        currentUser: [],
      },
      importUsers: {
        permissions: [10],
        currentUser: [],
      },
      editUserStatus : {
        permissions: [10],
        currentUser: [1, 4, 6, 8],
        requiresPreference: 'edit_status_checkin_exclusion'
      },
      editCheckinExclusions : {
        permissions: [10],
        currentUser: [1, 4, 6, 8],
        requiresPreference: 'edit_status_checkin_exclusion'
    },
  },
    units: {
      viewUnit: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      addUnit: { permissions: [8, 10], currentUser: [] },
      editUnit: { permissions: [8, 10], currentUser: [] },
      addUnitCheckinProfile: { permissions: [8, 10], currentUser: [] },
      editUnitCheckinProfile: { permissions: [8, 10], currentUser: [] },
      exportUnits: {
        permissions: [10],
        currentUser: [],
      },
      importUnits: {
        permissions: [10],
        currentUser: [],
      },
    },
    navBar: {
      dashboard: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      administration: { permissions: [6, 8, 10], currentUser: [] },
      installSetup: { permissions: [10], currentUser: [] },
      quickMessage: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      reminders: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      staff: { permissions: [6, 8, 10], currentUser: [] },
      messaging: { permissions: [4, 6, 8, 10], currentUser: [] },
      reports: { permissions: [4, 6, 8, 10], currentUser: [] },
      users: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
      units: { permissions: [0, 1, 4, 6, 8, 10], currentUser: [] },
    },
    devices: {
      addDeviceAssociation: { permissions: [6, 8, 10], currentUser: [] },
      editDeviceAssociation: { permissions: [6, 8, 10], currentUser: [] },
      deleteDeviceAssociation: { permissions: [6, 8, 10], currentUser: [] },
      alert: {
        addAlertGroup: { permissions: [6, 8, 10], currentUser: [] },
        editAlertGroup: { permissions: [6, 8, 10], currentUser: [] },
        deleteAlertGroup: { permissions: [6, 8, 10], currentUser: [] },
        addAlertDevice: { permissions: [6, 8, 10], currentUser: [] },
        editAlertDevice: { permissions: [6, 8, 10], currentUser: [] },
        addAlertDeviceCategory: { permissions: [6, 8, 10], currentUser: [] },
        editAlertDeviceCategory: { permissions: [6, 8, 10], currentUser: [] },
        addAlertDeviceType: { permissions: [10], currentUser: [] },
        editAlertDeviceType: { permissions: [10], currentUser: [] },
      },
      alarm: {
        addAlarmDevice: { permissions: [6, 8, 10], currentUser: [] },
        editAlarmDevice: { permissions: [6, 8, 10], currentUser: [] },
        addAlarmDeviceType: { permissions: [6, 10], currentUser: [] },
        editAlarmDeviceType: { permissions: [6, 10], currentUser: [] },
      },
      assignDevices:{
        permissions: [10],
        currentUser: []
      }
    },

    DocAndImages :{
      addCategoryFile : {permissions: [8, 10], currentUser: []},
      editDeleteCatOrFile : {permissions: [8, 10], currentUser: []},
      associateDevices : {permissions: [6], currentUser: []},
    }
  },
};

export default permissions;
